import { render, staticRenderFns } from "./ProgressDetail.vue?vue&type=template&id=6ff7459f"
import script from "./ProgressDetail.vue?vue&type=script&lang=js"
export * from "./ProgressDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports